import React, { useRef } from "react";
import { BsCheckAll } from "react-icons/bs";
import { CopyIcon } from "../../../static/images/icons";
import { useCopyToClipboard } from "../../hooks";
import { mergeClassName } from "../../utils/helpers";
import { BLOCKCHAIN_NETWORKS } from "@/common/utils/helpers/networks";

type Props = {
  walletAddress: string;
  loading: boolean;
  network?: string;
  asset?: string;
};

function ClipboardCopy({
  walletAddress,
  loading,
  network = BLOCKCHAIN_NETWORKS[0].title,
  asset = "USDT",
}: Props) {
  const addressRef = useRef<HTMLHeadingElement | null>(null);
  const { copyToClipboard, isCopied } = useCopyToClipboard();

  const handleCopyClick = () => {
    if (loading) return;
    copyToClipboard(walletAddress);
  };

  const instructions = [
    `Send only ${asset} to this deposit address.`,
    `Ensure the network is ${network}.`,
    "Do not send other coin to this address.",
  ];

  return (
    <>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-4">
        <h4
          className={mergeClassName(
            "text-xl font-bold text-gray-410 break-words  w-full",
            loading && "animate-pulse blur-sm"
          )}
          ref={addressRef}
        >
          {walletAddress}
        </h4>
        <button
          type="button"
          className={mergeClassName(
            "text-90 flex items-center gap-x-2",
            isCopied ? "animate-pulse text-green-10" : "text-gray-30"
          )}
          onClick={handleCopyClick}
        >
          {isCopied ? (
            <BsCheckAll className="text-2xl" />
          ) : (
            <span>
              <CopyIcon scale={0.75} />
            </span>
          )}
          <span>{isCopied ? "Address Copied!" : "Copy Address"}</span>
        </button>
      </div>
      <p className="pt-4 text-sm text-base-40">
        Network - <span className="font-bold text-gray-410">{network}</span>
      </p>
      <ul className="mt-5 list-inside list-disc text-base text-red-20">
        {instructions.map((itm) => (
          <li key={itm}>{itm}</li>
        ))}
      </ul>
    </>
  );
}

export default ClipboardCopy;
